var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLTopnavUserCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconL-topnav-user-circle",
    x: 0.526,
    y: 0.631,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconL-topnav-user-circle1",
    serifid: "iconL-topnav-user-circle",
    d: "M20.531,1.634c10.487,-0 19,8.513 19,19c0,10.486 -8.513,19 -19,19c-10.486,-0 -19,-8.514 -19,-19c0,-10.487 8.514,-19 19,-19Zm10.899,32.195l-0.033,-0.06c-2.186,-3.727 -6.234,-6.229 -10.866,-6.229c-4.631,-0 -8.677,2.501 -10.896,6.285l-0.002,0.004c2.962,2.45 6.759,3.922 10.898,3.922c4.14,0 7.939,-1.473 10.899,-3.922Zm1.441,-1.337c2.958,-3.076 4.778,-7.256 4.778,-11.858c-0,-9.448 -7.67,-17.118 -17.118,-17.118c-9.447,0 -17.117,7.67 -17.117,17.118c-0,4.6 1.818,8.778 4.775,11.855c1.787,-2.869 4.547,-5.072 7.901,-6.17c-2.552,-1.517 -4.262,-4.302 -4.262,-7.487c-0,-4.807 3.896,-8.704 8.703,-8.704c4.807,0 8.704,3.897 8.704,8.704c0,3.167 -1.691,5.939 -4.26,7.481c3.284,1.059 6.06,3.255 7.896,6.179Zm-19.117,-13.655c0,0.063 -0,0.051 -0,-0.001c-0,-0.002 -0,-0 -0,-0c-0,-3.743 3.034,-6.777 6.777,-6.777c3.743,-0 6.778,3.034 6.778,6.777c-0,3.743 -3.035,6.777 -6.778,6.777c-3.741,-0.004 -6.773,-3.035 -6.777,-6.776Z",
    style: {
      fill: "#808080"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLTopnavUserCircle);
export default __webpack_public_path__ + "static/media/iconL-topnav-user-circle.812e9b3d3761171a3df5d8c8867ffb28.svg";
export { ForwardRef as ReactComponent };